
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"63","height":"63","viewBox":"0 0 63 63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.356 31.506v.01c0 19.276-17.69 34.426-37.72 30.097-11.598-2.506-20.727-11.64-23.223-23.24C-2.893 18.376 12.197.727 31.427.673c.025 0 .045.02.045.045v12.209c0 .024-.02.042-.045.045-10.201.047-18.458 8.33-18.458 18.545 0 10.216 8.304 18.544 18.546 18.544 10.241 0 18.543-8.304 18.543-18.544v-.008h12.298v-.003z","fill":"#17375C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.296 5.16v20.113H49.984V12.994H37.708V.684H57.82a4.476 4.476 0 014.476 4.476z","fill":"#00ADDE"}})])
          )
        }
      }
    